import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	cultures: [],
};

export default function culturesReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_CULTURES_SUCCESS:
			return {
				...state,
				cultures: action.cultures,
			};

		default:
			return state;
	}
}
